'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoveApi = require('../lib/CoveApi');

var _CoveApi2 = _interopRequireDefault(_CoveApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the test api, used for checking connection to server & deployment
 */
var Test = function (_CoveAPI) {
  (0, _inherits3.default)(Test, _CoveAPI);

  /**
   * Creates a new Test API Client
   * @param {string} host
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, refreshInterval: number}} auth
   */
  function Test(host, environment, auth) {
    (0, _classCallCheck3.default)(this, Test);
    return (0, _possibleConstructorReturn3.default)(this, (Test.__proto__ || (0, _getPrototypeOf2.default)(Test)).call(this, host, 'test/v1', environment, auth));
  }

  (0, _createClass3.default)(Test, [{
    key: 'echo',
    value: function echo(query) {
      return this.apiClient.fetch('GET', 'echo', query);
    }
  }]);
  return Test;
}(_CoveApi2.default);

exports.default = Test;